module.exports = __webpack_public_path__ + "img/anniston-army-logo.bacb73b8.jpg";